import DomainsTable from './DomainsTable.vue';

export default DomainsTable;
